
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 0c2.761 0 5 2.248 5 5.02 0 .136-.008.272-.019.406a5.674 5.674 0 00-4.373 3.827V6.067h1.204l.18-1.402H5.607V3.77c0-.406.112-.683.692-.683h.74V1.832a9.96 9.96 0 00-1.078-.055c-1.066 0-1.796.655-1.796 1.855v1.034H2.96v1.402h1.206v3.899A5.012 5.012 0 010 5.02C0 2.248 2.239 0 5 0z","fill":"#0075FB"}}),_c('path',{attrs:{"d":"M13.02 6A2.983 2.983 0 0116 8.98v4.04A2.983 2.983 0 0113.02 16H8.98A2.983 2.983 0 016 13.02V8.98A2.983 2.983 0 018.98 6h4.04zM8.98 7.01c-1.09 0-1.974.884-1.974 1.973v4.042c0 1.09.884 1.973 1.974 1.973h4.042c1.089 0 1.972-.883 1.972-1.973V8.983c0-1.09-.883-1.972-1.973-1.972H8.98zM11 8.5c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5A2.503 2.503 0 018.5 11c0-1.378 1.121-2.5 2.5-2.5zm-.001.969a1.527 1.527 0 100 3.055 1.527 1.527 0 000-3.055zm2.813-1.594a.312.312 0 110 .625.312.312 0 010-.625z","fill":"url(#paint0_linear_9756_80839)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_9756_80839","x1":"15.947","y1":"15.971","x2":"15.947","y2":"6.078","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#E09B3D"}}),_c('stop',{attrs:{"offset":".3","stop-color":"#C74C4D"}}),_c('stop',{attrs:{"offset":".6","stop-color":"#C21975"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#7024C4"}})])])])
          )
        }
      }
    